import { useTranslation } from 'react-i18next';
import {
	splitForCurrentTeamAndRest,
	useOrganisationData,
} from '../../view/components/useOrganisationData';

export const useTeamData = ({
	teamUuid,
	organisationUuid,
}: {
	teamUuid: string;
	organisationUuid: string;
}): TeamDataState => {
	const { t } = useTranslation();
	const { loading, organisation } = useOrganisationData({ uuid: organisationUuid });

	if (loading) {
		return { state: 'loading' };
	}

	if (!organisation) {
		return { state: 'error', errorMessage: t('organisation-not-found') };
	}
	const { currentTeam, otherTeams } = splitForCurrentTeamAndRest(organisation.teams, teamUuid);

	if (!currentTeam) {
		return { state: 'error', errorMessage: t('teams.team-not-found') };
	}

	return { state: 'success', currentTeam, otherTeams, allTeams: organisation.teams };
};
type TeamDataState = LoadingState | ErrorState | SuccessState;

type LoadingState = {
	state: 'loading';
};
type ErrorState = {
	state: 'error';
	errorMessage: string;
};
type SuccessState = {
	state: 'success';
	currentTeam: Team;
	otherTeams: Team[];
	allTeams: Team[];
};

export type Team = NonNullable<ReturnType<typeof useOrganisationData>['organisation']>['teams'][0];
